// extracted by mini-css-extract-plugin
export var TooltipArrow = "LabelCell-module--TooltipArrow--a0e55";
export var TooltipContent = "LabelCell-module--TooltipContent--be1b1";
export var labelCell = "LabelCell-module--labelCell--bf5f9";
export var labelCell__paragraph = "LabelCell-module--labelCell__paragraph--c1bc7";
export var slideUpAndFade = "LabelCell-module--slideUpAndFade--fc5ad";